import { onMounted, onBeforeUnmount, type Ref } from 'vue'

/**
 * Composable to detect clicks outside of a given element
 * @param elementRef - The element reference to watch
 * @param callback - The function to call when a click outside is detected
 */
export function useClickOutside(
  elementRef: Ref<HTMLElement | undefined | null>,
  callback: () => void,
) {
  const handleClickOutside = (event: MouseEvent) => {
    const element = elementRef.value
    if (element && event.target instanceof Node && !element.contains(event.target)) {
      callback()
    }
  }

  onMounted(() => {
    document.addEventListener('click', handleClickOutside)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside)
  })

  return {
    handleClickOutside,
  }
}
